import { CopyOutlined, LoadingOutlined } from "@ant-design/icons";
import { App, Flex } from "antd";
import { FC, SyntheticEvent, useRef } from "react";
import { ContractProduct, Product } from "tm-shared/types";

import { useInViewObserver } from "@/hooks";
import { PrimaryText } from "@/shared/ui/Typography";
import { copyObjectToClipboard } from "@/utils/dom/copyObjectToClipboard";

import {
    StyledCheckbox,
    StyledProductBarcode,
    StyledProductInfoText,
    StyledRemainingCount,
} from "./Styled";

interface CheckboxProductRowProps {
    product: Product;
    checked: boolean;
    isLast: boolean;
    itemsLeft?: number;
    itemsLeftLoading?: boolean;
    onChange: (product: ContractProduct, checked: boolean) => void;
    onInView: () => void;
}

export const CheckboxProductRow: FC<CheckboxProductRowProps> = ({
    product,
    checked,
    isLast,
    itemsLeft,
    itemsLeftLoading,
    onChange,
    onInView,
}) => {
    const { notification } = App.useApp();

    const cardRef = useRef<HTMLDivElement>(null);

    useInViewObserver(cardRef, () => {
        if (isLast) onInView();
    });

    const handleCopyBarcode = (event: SyntheticEvent) => {
        event.preventDefault();
        event.stopPropagation();
        copyObjectToClipboard(
            {
                barcode: product.barcode,
                name: product.name,
                itemsLeft: itemsLeft ?? 0,
            },
            notification,
        );
    };

    return (
        <div ref={cardRef}>
            <StyledCheckbox
                checked={checked}
                onChange={(e) =>
                    onChange(
                        {
                            barcode: product.barcode,
                            quantity: 1,
                            price: 0,
                            name: product.name,
                        },
                        e.target.checked,
                    )
                }
            >
                <Flex vertical gap={4} align="flex-start">
                    <PrimaryText fontSize={14}>{product.name}</PrimaryText>
                    <StyledProductInfoText>
                        Штрихкод:{" "}
                        <StyledProductBarcode onClick={handleCopyBarcode}>
                            {product.barcode} <CopyOutlined />
                        </StyledProductBarcode>
                    </StyledProductInfoText>
                    <StyledProductInfoText>
                        Залишок:{" "}
                        <StyledRemainingCount>
                            {itemsLeftLoading ? (
                                <LoadingOutlined
                                    spin
                                    style={{ marginLeft: 4 }}
                                />
                            ) : (
                                itemsLeft ?? 0
                            )}
                        </StyledRemainingCount>
                    </StyledProductInfoText>
                </Flex>
            </StyledCheckbox>
        </div>
    );
};
